// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-table th.datetime,\n.el-table td.datetime {\n  width: 9em;\n}\n.el-table td.datetime {\n  padding: 0 0.5em;\n}", ""]);
// Exports
module.exports = exports;
